import dayjs from 'dayjs';

export const orchestraSessionFormValues = session => {
    const [start, end] = String(session.time || '').split('-');
    return {
        venue: session.venue,
        date: session.date ? dayjs(session.date) : undefined,
        timeRange: start && end ? [dayjs(`2000-01-01T${start}`), dayjs(`2000-01-01T${end}`)] : undefined,
        complimentaryQuota: session.complimentaryQuota,
    };
};

export const orchestraSessionPayload = (values, id) => ({
    ...(id ? { id } : {}),
    venue: values.venue,
    date: values.date.format('YYYY-MM-DD'),
    time: values.timeRange.map(value => value.format('HH:mm')).join('-'),
    complimentaryQuota: values.complimentaryQuota,
});
